import React from "react";
import { Button } from "./Button";

export interface DangerZoneItem {
  title: string;
  description: React.ReactNode;
  actionLabel: string;
  onClick: () => void;
  loading?: boolean;
}

interface DangerZoneProps {
  title?: string;
  items: DangerZoneItem[];
}

// Ações destrutivas ficam sempre juntas, no fim da página, com borda vermelha.
export const DangerZone: React.FC<DangerZoneProps> = ({ title = "Zona de risco", items }) => {
  if (items.length === 0) return null;
  return (
    <section className="rounded-card border border-danger/30 bg-surface">
      <header className="border-b border-danger/20 px-4 py-3 sm:px-5">
        <h2 className="text-heading font-semibold text-danger">{title}</h2>
      </header>
      <ul className="divide-y divide-line">
        {items.map((item) => (
          <li
            key={item.title}
            className="flex flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-5"
          >
            <div className="min-w-0">
              <p className="text-body font-medium text-fg">{item.title}</p>
              <p className="mt-0.5 text-caption text-fg-muted">{item.description}</p>
            </div>
            <Button
              variant="danger-ghost"
              className="border border-danger/30"
              loading={item.loading}
              onClick={item.onClick}
            >
              {item.actionLabel}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
};
